import { FC } from "react";
import { useTrans } from "../../../hooks";
import { Button, HStack, Text } from "@chakra-ui/react";
import {
    DataType,
    IKaTableProps,
    ITableInstance,
    Table as KaTable,
    SortingMode,
} from "ka-table";
import { Column, PagingOptions } from "ka-table/models";
import { ICellTextProps } from "ka-table/props";
import { AppIcon, KaPageSizeSelector } from "../../../components";

export const FindInternshipCompanyList: FC<{
    table: ITableInstance;
    paging: PagingOptions;
    list: any[];
    loadingList?: boolean;
    onActionClick?: (key: string, data?: any) => void;
}> = ({
    table,
    paging,
    list,
    loadingList = false,
    onActionClick = () => {},
}) => {
    const { t } = useTrans();
    const columns: Column[] = [
        {
            key: "name",
            title: t("ent.Internship:name.label"),
            dataType: DataType.String,
        },
        {
            key: "company",
            title: t("ent.Internship:company.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "service",
            title: t("ent.Internship:service.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "typology",
            title: t("ent.Internship:typology.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "action",
            title: "",
            style: { textAlign: "right" },
            dataType: DataType.Object,
            width: 50,
            isSortable: false,
        },
    ];

    const kaTableProps: IKaTableProps = {
        table: table,
        columns: columns,
        data: list || [],
        loading: {
            enabled: loadingList,
        },
        paging: paging,
        rowKeyField: "id",
        sortingMode: SortingMode.SingleRemote,
        childComponents: {
            pagingSizes: {
                content: (props) => <KaPageSizeSelector {...props} />,
            },
            cellText: {
                content: (props: ICellTextProps) => {
                    switch (props?.column?.key) {
                        case "name":
                            return (
                                <Text
                                    textStyle={"mediumSm"}
                                    color={"var(--chakra-colors-black)"}
                                >
                                    {props?.rowData?.name}
                                </Text>
                            );
                        case "company":
                            return <Text>{props?.rowData?.company?.name}</Text>;
                        case "service":
                            return <Text>{props?.rowData?.service?.name}</Text>;
                        case "typology":
                            return (
                                <Text>{props?.rowData?.typology?.name}</Text>
                            );
                        case "action":
                            return (
                                <HStack justify={"flex-end"} gap={3}>
                                    <Button
                                        variant={"outline"}
                                        className="btn-icon-xs"
                                        size="xs"
                                        title={t(
                                            "padm.InternshipPage:text.option.internshipSchedule"
                                        )}
                                        onClick={() =>
                                            onActionClick(
                                                "internshipSchedule",
                                                props?.rowData
                                            )
                                        }
                                    >
                                        <AppIcon
                                            name="icl-calendar"
                                            w="0.8rem"
                                        />
                                    </Button>
                                </HStack>
                            );
                    }
                },
            },
        },
    };

    return <KaTable {...kaTableProps} />;
};
